import Text from "../../../design-system/primitives/components/Text/Text";
import Tabs from "../../../design-system/primitives/components/Tabs/Tabs";
import PageShell from "../../../design-system/components/PageShell/PageShell";
import type { WorkshopStepInfo } from "../../../api/workshop";
import StudentsOverview from "./StudentsOverview";
import TeachersOverview from "./TeachersOverview";
import styles from "./InviteOverview.css";

const InviteOverview = ({ workshop }: { workshop: WorkshopStepInfo }) => {
  const tabs = [
    {
      label: "Schüler*innen",
      value: "students",
      content: <StudentsOverview workshop={workshop} />,
    },
    {
      label: "Kolleg*innen",
      value: "teachers",
      content: <TeachersOverview workshop={workshop} />,
    },
  ];

  return (
    <Tabs.Root defaultValue="students">
      <PageShell
        surface="dark"
        showBackdrop={false}
        bordered={false}
        titleButton={{ icon: "arrow-left", ariaLabel: "Zurück", to: ".." }}
        titleSlot={
          <div className={styles.headerRow}>
            <Text variant="h4">Einladen</Text>

            <div className={styles.tabs}>
              <Tabs.List
                tabs={tabs}
                ariaLabel="Einzuladende Personengruppe auswählen"
              />
            </div>
          </div>
        }
        bodySlot={tabs.map((tab) => (
          <Tabs.Content key={tab.value} value={tab.value}>
            {tab.content}
          </Tabs.Content>
        ))}
      />
    </Tabs.Root>
  );
};

export default InviteOverview;
